import { API_ROUTES } from '@/constants/apiRoutes';
import { AxiosInstance } from 'axios';
import { LocationData } from './locations.types';

export interface LocationPayload {
  locationId: string;
  locationName: string;
  locationImage: string;
  locationURL: string;
  latitude: string;
  longitude: string;
  locationSubtitle: string;
}

export interface LocationStatusPayload {
  locationId: string;
  locationStatus: string;
}

const updateLocationDetails = (client: AxiosInstance) => async (payload: LocationPayload) => {
  return (await client.post<{ message: string; data: LocationData }>(API_ROUTES.UPDATE_LOCATION_DETAIL, payload)).data;
};

const updateLocationStatus = (client: AxiosInstance) => async (payload: LocationStatusPayload) => {
  return (await client.post<{ message: string; data: LocationData }>(API_ROUTES.UPDATE_LOCATION_STATUS, payload)).data;
};

export const locationMutations = {
  updateLocationDetails,
  updateLocationStatus,
};
